/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoiceDetailsSave: "invoice-details-save",
  invoiceDetailsTotals: "invoice-details-totals",
  invoiceDetailsRecalculate: "invoice-details-recalculate",
  invoiceDetailsSeparate: "invoice-details-separate",
} as const;
